import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class RegulatoryBarService {
	private dynamicHeight$ = new BehaviorSubject<number | undefined>(undefined);
	private isAamsRegulatoryBarEnabled$ = new BehaviorSubject<boolean | undefined>(undefined);

	regulatoryBarDynamicHeight$(): Observable<number | undefined> {
		return this.dynamicHeight$;
	}

	setRegulatoryBarDynamicHeight(height: number | undefined) {
		this.dynamicHeight$.next(height);
	}

	aamsRegulatoryBarEnabled$(): Observable<boolean | undefined> {
		return this.isAamsRegulatoryBarEnabled$;
	}

	setAamsRegulatoryBarEnabled(isEnabled: boolean | undefined) {
		this.isAamsRegulatoryBarEnabled$.next(isEnabled);
	}
}
